import React from "react"
import {
    AddIcon,
    Button,
    Checkbox,
    Dropdown,
    Flex,
    Input,
    Text,
    TextArea
} from "@fluentui/react-northstar"

import ButtonForm from "./ButtonForm"
import {
    INotificationFormData as INotificationFormData,
    IButtonData
} from "./Types"

export interface IBuildProps {
    notificationForm: INotificationFormData;
    titleChanged: any;
    subtitleChanged: any;
    imageLinkChanged: any;
    summaryChanged: any;
    requireConfirmationChange: any;
    requireConfirmationButtonTextChange: any;
    sendMeetingChange: any;
    selectedMeetingChange: any;
    addButtonClick: any;
    deleteButtonClick: any
    buttonTextChanged: any;
    buttonUrlChanged: any;
}

export default function NotificationForm(props: IBuildProps) {

    return (
        <Flex className="scrollableContent">
            <Flex.Item size="size.half">
                <Flex column className="formContentContainer">
                    <h3>Notificacion</h3>
                    
                    <Input className="inputField"
                        value={props.notificationForm.title}
                        label="Titulo"
                        placeholder="Titulo"
                        onChange={props.titleChanged}
                        autoComplete="off"
                        fluid
                    />

                    <Input className="inputField"
                        value={props.notificationForm.subtitle}
                        label="Subtitulo"
                        placeholder="Subtitulo"
                        onChange={props.subtitleChanged}
                        autoComplete="off"
                        fluid
                    />

                    <Input fluid className="inputField"
                        value={props.notificationForm.imageLink}
                        label="URL de la imagen"
                        placeholder="URL de la imagen"
                        onChange={props.imageLinkChanged}
                        error={!(props.notificationForm.imageLinkError === "")}
                        autoComplete="off"
                    />
                    <Text className={(props.notificationForm.imageLinkError === "") ? "hide" : "show"}
                        error
                        size="small"
                        content={props.notificationForm.imageLinkError}
                    />

                    <div className="textArea">
                        <Text content="Resumen" />
                        <TextArea autoFocus
                            placeholder="Resumen"
                            value={props.notificationForm.summary}
                            onChange={props.summaryChanged}
                            fluid />
                    </div>

                    <Checkbox className="checkbox" label="Requiere confirmación"
                        onChange={props.requireConfirmationChange}
                        checked={props.notificationForm.requireConfirmation}
                        toggle />
                    {
                        props.notificationForm.requireConfirmation && (
                            <Input className="inputField"
                                value={props.notificationForm.requireConfirmationButton.title}
                                label="Texto del boton de confirmación"
                                placeholder="Confirmar"
                                onChange={props.requireConfirmationButtonTextChange}
                                autoComplete="off"
                                fluid
                            />
                        )
                    }

                    <Checkbox className="checkbox" label="Enviar reunión"
                        onChange={props.sendMeetingChange}
                        checked={props.notificationForm.sendMeeting}
                        toggle />
                    {
                        props.notificationForm.sendMeeting && (
                            <Dropdown className="selectMeetingDropdown"
                                items={props.notificationForm.meetings}
                                value={props.notificationForm.selectedMeeting}
                                loading={props.notificationForm.meetingsLoading}
                                loadingMessage="Cargando..."
                                placeholder="Seleccione una reunión"
                                getA11ySelectionMessage={{ onAdd: item => props.selectedMeetingChange(item) }}
                                noResultsMessage="No hemos podido encontrar ninguna coincidencia."
                            />
                        )
                    }

                    <Button className="inputButton"
                        icon={<AddIcon />}
                        content="Nuevo boton"
                        title="Add"
                        onClick={() => props.addButtonClick()}
                    />
                    {
                        props.notificationForm.buttons.map((button: IButtonData) => (
                            <ButtonForm button={button}
                                buttonTextChanged={props.buttonTextChanged}
                                buttonUrlChanged={props.buttonUrlChanged}
                                deleteButtonClick={props.deleteButtonClick} />
                        ))
                    }
                </Flex>
            </Flex.Item>
            <Flex.Item size="size.half">
                <div className="adaptiveCardContainer">
                </div>
            </Flex.Item>
        </Flex>
    )
}